import red from "@mui/material/colors/red";
import green from "@mui/material/colors/green";

const themes = [
  {
    id: "default",
    color: "#05735A",
    source: {
      palette: {
        mode: "light",
        primary: { main: "#05735A" },
        secondary: {
          main: "#931e69",
        },
        background: {
          default: "#f2f6f4",
          paper: "#ffffff",
        },
        text: {
          primary: "#1a1a1a",
          secondary: "#49454f",
        },
        info: {
          main: "#D2E9DF",
          contrastText: "#49454F",
        },
      },
    },
  },
  {
    id: "dark",
    color: "#0a9d7a",
    source: {
      palette: {
        mode: "dark",
        primary: { main: "#0a9d7a" },
        secondary: {
          main: "#e91e8c",
        },
        background: {
          default: "#1a1a1a",
          paper: "#252525",
        },
        text: {
          primary: "#f5f5f5",
          secondary: "#d0d0d0",
        },
        info: {
          main: "#1a2d3d",
          contrastText: "#90caf9",
        },
        divider: "#333333",
      },
      components: {
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: "none",
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              backgroundImage: "none",
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            contained: {
              boxShadow: "none",
            },
          },
        },
      },
    },
  },
  {
    id: "red",
    color: "#d42b20",
    source: {
      palette: {
        mode: "light",
        primary: { main: "#d42b20" },
        secondary: {
          main: "#c62828",
        },
        info: {
          main: "#D2E9DF",
        },
      },
    },
  },
  {
    id: "green",
    color: green[500],
    source: {
      palette: {
        mode: "light",
        primary: green,
        secondary: red,
        error: red,
        info: {
          main: "#D2E9DF",
        },
      },
    },
  },
];

export default themes;
